import React, { useState } from 'react';
import { db } from '../firebaseConfig';
import { collection, addDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './GenerateLink.css';
import { useTranslation } from 'react-i18next';

const generateToken = (length = 16) => {
  const chars = 'abcdef0123456789';
  let token = '';
  for (let i = 0; i < length * 2; i++) {
    token += chars[Math.floor(Math.random() * chars.length)];
  }
  return token;
};

const GenerateLink = () => {
  const [name, setName] = useState('');
  const [organization, setOrganization] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [link, setLink] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const coffeeShopId = localStorage.getItem('coffee_shop_id');
    const coffeeShopName = localStorage.getItem('coffee_shop_name');

    if (!name || !organization || !email || !phone) {
      setMessage(t('generate_link_all_fields_required'));
      return;
    }

    if (!coffeeShopId || !coffeeShopName) {
      setMessage(t('generate_link_shop_info_missing'));
      return;
    }

    const token = generateToken();
    const domain = window.location.origin;
    const purchaseLink = `${domain}/customer/${token}`;

    try {
      await addDoc(collection(db, 'customers'), {
        name,
        organization,
        email,
        phone,
        coffee_shop_id: coffeeShopId,
        coffee_shop_name: coffeeShopName,
        token,
        customer_link: purchaseLink,
        coffees_purchased: 0,
        created_at: new Date(),
      });

      setLink(purchaseLink);
      setMessage(t('generate_link_success'));
      setName('');
      setOrganization('');
      setEmail('');
      setPhone('');
    } catch (error) {
      setMessage(t('generate_link_error') + error.message);
    }
  };

  return (
    <div className="generate-link-container">
      <h1>{t('generate_link_title')}</h1>
      {message && <p className="message">{message}</p>}
      {link && (
        <div className="generated-link">
          <strong>{t('generate_link_label')}:</strong>{' '}
          <a href={link} target="_blank" rel="noopener noreferrer">
            {link}
          </a>
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder={t('generate_link_name')} required />
        <input type="text" value={organization} onChange={(e) => setOrganization(e.target.value)} placeholder={t('generate_link_org')} required />
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('generate_link_email')} required />
        <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder={t('generate_link_phone')} required />
        <button type="submit">{t('generate_link_button')}</button>
      </form>
      <button className="back-dashboard" onClick={() => navigate('/dashboard')}>
        {t('back_to_dashboard')}
      </button>
    </div>
  );
};

export default GenerateLink;
